import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PatientService {

  constructor(protected http: HttpClient) { }

  getPatients() {
    return this.http.get('api/patient/');
  }

  save(){

  }


}



// WEBPACK FOOTER //
// ./src/app/patient.service.ts